var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEsg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-105 -231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.191 265.203C120.27 276.124 120.27 293.887 131.191 304.809 136.672 310.29 143.833 313.01 150.994 313.01 158.156 313.01 165.317 310.29 170.798 304.809 184.72 290.887 187 249 187 249 187 249 145.113 251.28 131.191 265.203ZM165.157 299.168C161.356 302.928 156.355 305.009 150.994 305.009 147.434 305.009 144.073 304.009 141.073 302.288 144.753 290.767 151.555 280.645 160.596 273.004 150.074 278.445 141.233 286.846 135.112 297.008 129.191 289.166 129.711 278.005 136.872 270.843 143.833 263.882 163.156 259.602 178.199 257.801 176.398 272.844 172.118 292.167 165.157 299.168Z",
    fill: "#FFFFFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsg);
export default __webpack_public_path__ + "static/media/esg.90af29c4fce63b4cc162d839e83515fb.svg";
export { ForwardRef as ReactComponent };